const IP_REGEX_PATTERN = String.raw`((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)\.){3}(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)`;
const CIDR_REGEX_PATTERN = String.raw`(/([0-9]|[1-2][0-9]|3[0-2]))`;

export const IP_WITH_CIDR_REGEX = new RegExp(`^${IP_REGEX_PATTERN}${CIDR_REGEX_PATTERN}$`);
export const IP_WITH_OPTIONAL_CIDR_REGEX = new RegExp(`^${IP_REGEX_PATTERN}${CIDR_REGEX_PATTERN}?$`);


export function createIPWithCIDR(ipAddress: string, cidr: string = '32'): string {
  return `${ipAddress}/${cidr}`;
}

export function normalizeIPToIPWithCIDR(ipAddress: string, cidr: string = '32'): string {
  if (IP_WITH_CIDR_REGEX.test(ipAddress)) {
    return ipAddress;
  } else if (IP_WITH_OPTIONAL_CIDR_REGEX.test(ipAddress)) {
    return createIPWithCIDR(ipAddress, cidr);
  } else {
    throw new Error(`Invalid IP address: ${ipAddress}`);
  }
}
